
import { State } from "@/store";
import { defineComponent } from "vue";
import { mapState } from "vuex";

export default defineComponent({
    computed: {
        ...mapState({
            qrcodeObject: (state: State) => state.qrcode.qrcodeObject,
            isBanned: (state: State) => state.qrcode.isBanned
        })
    }
});
